import "./style.css";
import { jsx as l, jsxs as t, Fragment as m } from "react/jsx-runtime";
import { c as a } from "../../__shared__/index.js";
const p = "_container_14lgq_12", d = "_icons_14lgq_17", g = "_item_14lgq_30", h = "_icon_14lgq_17", u = "_labelWrapper_14lgq_49", b = "_label_14lgq_49", e = {
  container: p,
  icons: d,
  item: g,
  icon: h,
  labelWrapper: u,
  label: b
};
function f({
  icons: n,
  separator: c,
  className: i,
  ...o
}) {
  return !n || n.length === 0 ? null : /* @__PURE__ */ l("div", { ...o, className: a(e.container, i), children: /* @__PURE__ */ l("div", { className: a(e.icons), children: n.map(({ icon: s, label: r = "" }, _) => /* @__PURE__ */ t(m, { children: [
    /* @__PURE__ */ t("div", { className: a(e.item), children: [
      s && /* @__PURE__ */ l(
        "div",
        {
          className: a(e.icon),
          style: {
            /** @ts-ignore */
            "--url": `url(/shared_res/agility/next-components/assets/icons/${s}.svg)`
          }
        }
      ),
      /* @__PURE__ */ l("div", { className: e.labelWrapper, children: /* @__PURE__ */ l("span", { className: e.label, children: r }) })
    ] }, `${s}-${r}`),
    _ !== n.length - 1 && c
  ] })) }) });
}
export {
  f as default
};
//# sourceMappingURL=FeatureIcon.js.map
